package com.wintermar.inspection.navigation

actual fun handleForceLogoutPlatform(controller: NavigationController) {
    controller.navigateTo(Route.NotFound, removeAllExistingRoute = true)
}
